module.exports = __webpack_public_path__ + "media/flags/ye-963e65f0.svg";